import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  PostBanner,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const BannerEndpoint = {
  getBanners: `/admin/banner/list`,
  getOfferbyId: `/admin/content/details/`,
  deleteBanner: `/admin/banner/delete/`,
  editBanner: `/admin/banner/edit/`,
  addBanner: `/admin/banner/add`,
  uploadBanner: `/admin/banner/uploadImage`,
};

export const getBanners = (param = "") => {
  const url = getAPIUrl(BannerEndpoint.getBanners, param);
  return Get(HomePageService, url, true);
};
export const getOfferbyId = (param = "") => {
  const url = getAPIUrl(BannerEndpoint.getOfferbyId, param);
  return Get(HomePageService, url, true);
};
export const addBanner = (data, param = "") => {
  const url = getAPIUrl(BannerEndpoint.addBanner, param);
  return Post(HomePageService, url, data, true);
};

export const editBanner = (data, param = "") => {
  const url = getAPIUrl(BannerEndpoint.editBanner, param);
  return Put(HomePageService, url, data, true);
};

export const uploadBanner = (data, param = "") => {
  const url = getAPIUrl(BannerEndpoint.uploadBanner, param);
  return PostBanner(HomePageService, url, data, true, true); 
};


export const deleteBanner = (param = "") => {
  const url = getAPIUrl(BannerEndpoint.deleteBanner, param);
  return Delete(HomePageService, url, param);
};
